import { observer } from 'mobx-react';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import { localeStore } from '~/mobx/localesStore';
import CustomSelect from '~/view/components/Controls/Pickers/CustomSelect/CustomSelect';

interface IProps {
  options: IPickerOption[];
  defaultOptions: IPickerOption[];
  selectedOptions: IPickerOption[];
  placeholder?: string;
  onSelect: (options: IPickerOption[]) => void;
}

export const BranchPicker = (props: IProps): JSX.Element => {
  const selectBranches = (options: IPickerOption[]) => {
    props.onSelect(options);
  };

  return (
    <CustomSelect
      className="mr-2"
      inputClassName="report-header__picker"
      onSelect={selectBranches}
      options={props.options}
      optionsDesc="branches"
      emptyListText={localeStore.t('no_results_found')}
      isMulti
      isSearchable
      selectedOptions={props.selectedOptions}
      defaultOptions={props.defaultOptions}
      placeholder={props.placeholder}
    />
  );
};

export default observer(BranchPicker);
